module.exports = __webpack_public_path__ + "static/media/authorization_login_error.8dbbcf3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/Authentication/authorization_login_error.png
// module id = 1219
// module chunks = 0